import $ from 'jquery'
import 'slick-carousel'
import hljs from 'highlight.js';
import { embedPracticeGame } from 'practice_games_user/embed'

export function markupAddons($container) {
  markupVideoOverlay($container)
  initMarkupSlideshow($container)
  initHighlightjs()
  toggleExpandable($container)
  initPracticeGame()
}

function markupVideoOverlay($mainContainer) {
  const $markupVideoLink = $('.markup-video-link', $mainContainer)

  $markupVideoLink.on('click', function () {
    const videoData = $(this).data("video-id"),
        $modal = $(".markup-video[id=" + videoData + "]");

    SOPHIA.videoJsPlayer($mainContainer);

    SOPHIA.overlayBox($modal, {
      afterClose: function() {
        $.fancybox.destroy();
      }
    });
  })
}

function initPracticeGame() {
  $(document).on('ready', function() {
    embedPracticeGame()
  })
}

function initMarkupSlideshow($container) {
  $container.find('.slideshow').slick({
    dots: true,
    infinite: true,
    adaptiveHeight: true
  });
}

function initHighlightjs() {
  hljs.initHighlighting.called = false; // to reinit plugin without page reloading
  hljs.initHighlighting();
}

function toggleExpandable($container) {
  const $expandableLink = $('.markup-expandable-title', $container)
  $expandableLink.off('click')
  $expandableLink.off('keydown')

  $expandableLink.on('click', function (event) {
    toggleAccordion(event);
  })

  $expandableLink.on('keydown', function(event) {
    if (event.keyCode == $.ui.keyCode.ENTER) {
      toggleAccordion(event);
    }
  })
}

function toggleAccordion(event) {
  event.preventDefault();

  const $item = $(event.currentTarget).closest('.markup-expandable')
  const $itemAnswer = $(event.currentTarget).siblings('.markup-expandable-content')

  if ($item.hasClass('expanded')) {
    $item.removeClass('expanded')
    $itemAnswer.slideUp()
  } else {
    $item.addClass('expanded')
    $itemAnswer.slideDown()
  }
}
